import React, { useContext, useState, useEffect } from 'react'
import { getFunctions, httpsCallable } from "firebase/functions";

import { AuthContext } from '@/contexts/AuthContext'
import Button from '@/components/Button'
import modalRoutes from '../../../modalRoutes';

export default function AccountGeneral() {

  return (
    <div className="grid gap-6">
      <AccountForm />
    </div>
  )
}

const AccountForm = () => {
  const { accounts, userAccounts } = useContext(AuthContext)
  const [serverErrors, setServerErrors] = useState(null)

  return (
    <div className="border border-gray-800 rounded">
      <div className="px-4">
        <div className="py-4 border-b border-gray-800">
          <h2 className="font-medium text-xl mb-2">Linked Accounts</h2>
          <p className="text-gray-300">Your linked RS accounts available to use.</p>
        </div>
        <div className="py-3 grid gap-4">
          {userAccounts.length ? userAccounts.map((item, index) => <AccountItem item={item} key={index} />) : (
            <p className="py-8 text-center text-gray-300">You do not have any linked accounts. Please link an account below.</p>
          )}
        </div>
      </div>
      <div className="bg-gray-800 bg-opacity-50 border-t border-gray-800 px-4 py-3 flex justify-between">
        <p>{serverErrors}</p>
        <Button rounded="rounded-full" modifier="secondary" link to={modalRoutes.LINK_ACCOUNT} className="py-2.5 px-4">Link Account</Button>
      </div>
    </div>
  )
}

const AccountItem = ({ item }) => {
  const functions = getFunctions()
  const removeLinkedAccountByUser = httpsCallable(functions, 'removeLinkedAccountByUser')
  const makeAccountPrimary = httpsCallable(functions, 'makeAccountPrimary')
  const [isRemoving, setIsRemoving] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)
  const { accounts } = useContext(AuthContext)
  const handleRemove = async (id) => {
    try {
      setIsRemoving(true)
      await removeLinkedAccountByUser({ id })
    } catch (err) {
      console.log(err.message)
    }
    setIsRemoving(false)
  }
  const handleMakePrimary = async (id) => {
    try {
      setIsUpdating(true)
      await makeAccountPrimary({ id })
    } catch (err) {
      console.log(err.message)
    }
    setIsUpdating(false)
  }
  return (
    <div className="odd:bg-gray-800 p-3 rounded flex justify-between">
      <div className="flex space-x-2 items-center">
        <span>{item?.username}</span>
        <span className="mx-1 text-gray-300">&#8212;</span>
        {item?.primary ? (
          <span className="text-xs bg-purple-600 font-medium rounded-full px-1.5 py-px">Primary</span>
        ) : (
          <button onClick={() => handleMakePrimary(item.id)} className="text-xs text-gray-300 hover:text-gray-300 transition-all">
            {isUpdating ? (
              <svg className="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            ) : (
              <span>Make Primary</span>
            )}
          </button>
        )}
      </div>
      <button onClick={() => handleRemove(item.id)} className="text-xs underline text-red-500 hover:text-red-600 transition-all duration-300">
        {isRemoving ? (
          <svg className="animate-spin mr-4 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        ) : (
          <span>Remove</span>
        )}
      </button>
    </div>
  )
}